import type { Dispatch } from 'redux';
import { connect } from '@atlassian/jira-react-redux';
import { initiateUpdateComponent } from '../../../../state/actions';

import { getName } from '../../../../state/components/selectors';
import type { State } from '../../../../state/reducer';
import { deleteComponentStarted } from '../../../../state/ui/delete/actions';
import { showSpinner } from './selectors';

import ActionsView from './view';

type Props = {
	componentId: string;
};

const mapStateToProps = (state: State, ownProps: Props) => ({
	showSpinner: showSpinner(state, ownProps.componentId),
	name: getName(state, ownProps.componentId),
});

const mapDispatchToProps = (dispatch: Dispatch, ownProps: Props) => ({
	onEdit: () => dispatch(initiateUpdateComponent({ id: ownProps.componentId })),
	onDelete: () => dispatch(deleteComponentStarted({ id: ownProps.componentId })),
});

export default connect(mapStateToProps, mapDispatchToProps)(ActionsView);
